import { createApi, fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react'

import { RootState } from 'src/Redux'

import { ga } from './api'

const rawBaseQuery = fetchBaseQuery({
  prepareHeaders: (headers, { getState, endpoint }) => {
    const isCookies = ga && !endpoint?.startsWith
    const token = (getState() as RootState).authentication?.credentials
      ?.AccessToken
    if (token) {
      headers.set('authorization', `Bearer ${token}`)
    }
    if (isCookies) {
      headers.set('Cookies', ga)
    }
    return headers
  },
})

export const baseQuery = retry(rawBaseQuery, {
  maxRetries: 0,
})

export const rtkApi = createApi({
  baseQuery,
  tagTypes: [
    'newSound',
    'inProgressSound',
    'submittedSound',
    'Features',
    'CampaignVideo',
    'newRelease',
    'TikTokMinBudget',
    'TrackFeedDetails',
    'FeedTracks',
    'ReviewedFeedTracks',
    'SmartTracks',
    'PastMatchTracks',
    'ArtistNotifications',
    'CuratorNotifications',
    'Subscription',
    'SpotifyCampaignDetails',
    'Recipient',
    'WiseCurrencies',
    'SpotifyCampaign',
    'SpotifyCampaignReviews',
    'CuratorBalanceHistory',
    'MetaAdCampaign',
    'CuratorPlacementsRemoved',
    'CuratorAllPlacements',
    'CuratorPlacementsInPlaylist',
    'CuratorPlacementsScheduled',
    'CuratorPlacementsCounts',
    'FavoriteCurators',
    'MatchedCurators',
    'CuratorPlaylists',
    'ArtistOrder',
    'ArtistOrderCheckoutInfo',
    'CuratorSpotifyInfo',
    'monetizationData',
    'UsersMe',
    'TikTokCampaignDetails',
  ],
  endpoints: () => ({}),
})
